import { createContext, useContext } from 'react';

import { PAGE_FLOW } from '../constants';

import type { PageFlow } from '../types';

export interface LoginContextInterface {
  isNewUser: boolean;
  isLoggedIn: boolean;
  pageFlow: PageFlow;
  updateIsNewUser: (isNewUserValue: boolean) => void;
  updateIsLoggedIn: (isLoggedInValue: boolean) => void;
  updatePageFlow: (newLoginFlow: PageFlow) => void;
}

export const LoginContext = createContext<LoginContextInterface>({
  isNewUser: false,
  isLoggedIn: false,
  pageFlow: PAGE_FLOW.INTRO,
  updateIsNewUser: () => {},
  updateIsLoggedIn: () => {},
  updatePageFlow: () => {},
});

export const useLoginContext = () => useContext(LoginContext);
